<template>
  <div class="mw-500 pa-10 mx-auto">
    <div class="rating__logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="hasefulTitle hausefulDescription"
        role="img"
      >
        <title id="hasefulTitle">Hauseful</title>
        <path
          d="M25.4 38.48a7.908 7.908 0 0 0 1.192-4.159c.008-1.805-.111-4.041-.568-6.252-.55-2.664-1.462-4.706-2.71-6.067-1.11-1.21-2.493-1.875-4.214-2.017.922 1.694 1.402 3.287 1.48 4.863.126 2.515-.776 4.498-1.649 6.414-.536 1.18-1.09 2.399-1.408 3.778-.254 1.869.386 3.108.973 3.821.842 1.023 2.115 1.634 3.404 1.634.974 0 2.365-.345 3.479-1.98a.523.523 0 0 0 .012-.02l.01-.016ZM12.1 18.6l.002-.004c.511-1.188 2.076-4.697 2.4-5.32.625-1.202 1.79-3.44 1.93-4.174.333-1.782-.006-3.373-.979-4.602a5.304 5.304 0 0 0-4.125-1.996 4.69 4.69 0 0 0-3.303 1.336l-.005.005a.102.102 0 0 1-.008.007c-1.06 1.003-1.68 2.399-2.279 3.748v.002l-.209.466c-3.01 7.073-3.917 15.82-2.366 22.833.006.024.01.048.015.073.328 1.709 1.194 4.296 2.64 6.431.814 1.203 2.053 2.603 3.588 2.987-1.416-2.81-1.864-5.956-1.368-9.524.577-4.155 2.35-8.28 4.067-12.268Zm5.258-5.565a110.477 110.477 0 0 0-2.286 4.819c11.753-2.723 14.151 8.834 13.912 17.397a7.778 7.778 0 0 1-.79 3.227c-.23.466-.506.942-.823 1.444-4.176 6.206-13.362 2.313-12.215-5.356.373-1.681 1.007-3.075 1.6-4.377.68-1.494 1.304-2.865 1.412-4.41v-.016c0-5.277-3.768-6.376-3.768-6.376l-.1.232c-3.325 7.725-6.77 15.73-.79 22.488C6.31 45.915 1.8 36.614.811 31.464-.829 24.05.021 14.797 3.333 7.031c.07-.156.14-.316.213-.477.665-1.5 1.423-3.21 2.847-4.555 4.98-4.78 13.911-.49 12.403 7.582-.155.817-.767 2.13-1.438 3.455Zm29.103 11.34c1.895 0 3.424.546 4.586 1.639 1.162 1.092 1.743 2.64 1.743 4.644v10.585h-3.621v-9.63c0-1.297-.339-2.276-1.015-2.936-.678-.66-1.591-.99-2.742-.99-1.15 0-2.07.387-2.759 1.16-.688.775-1.032 1.856-1.032 3.245v9.15H38V17.342h3.621v9.254c1.128-1.48 2.742-2.22 4.84-2.22Zm19.223 13.18c.7-.728 1.05-1.741 1.05-3.04V33.8l-4.705.546c-1.715.228-2.572.99-2.572 2.288 0 .751.327 1.31.981 1.673.654.365 1.444.524 2.37.478 1.218-.09 2.177-.5 2.876-1.23Zm4.67-6.897v6.829c0 .637.316.956.948.956.113 0 .327-.034.643-.103v3.074c-.406.113-.88.17-1.421.17-1.895 0-3.091-.728-3.588-2.185-1.196 1.457-2.933 2.185-5.212 2.185-1.737 0-3.147-.438-4.23-1.314-1.083-.876-1.625-2.089-1.625-3.637 0-1.502.508-2.675 1.523-3.517 1.016-.842 2.324-1.343 3.926-1.502l5.415-.581v-.307c0-1.07-.327-1.907-.98-2.51-.656-.603-1.502-.905-2.54-.905-.857 0-1.585.217-2.182.649-.599.433-.999 1.047-1.202 1.844l-3.215-.58c.338-1.64 1.128-2.857 2.369-3.654 1.24-.797 2.719-1.196 4.434-1.196 2.143 0 3.835.547 5.076 1.64 1.241 1.092 1.862 2.64 1.862 4.644Zm14.469 6.436c.688-.785 1.032-1.861 1.032-3.227v-9.151h3.622v16.527h-3.622V39.4c-1.128 1.457-2.73 2.185-4.806 2.185-1.783 0-3.289-.574-4.518-1.724-1.23-1.15-1.845-2.783-1.845-4.9V24.717h3.622v9.97c0 1.14.343 2.021 1.032 2.647.688.626 1.608.94 2.758.94 1.128 0 2.036-.394 2.725-1.179Zm20.188-3.62c.27.24.468.496.592.769.124.273.237.586.338.939.102.353.153.734.153 1.144 0 1.639-.643 2.925-1.929 3.858-1.286.934-2.889 1.4-4.806 1.4-1.76 0-3.261-.398-4.502-1.195-1.24-.797-2.03-1.912-2.369-3.346l3.046-.888c.203.797.643 1.406 1.32 1.827.677.421 1.478.632 2.403.632s1.675-.194 2.251-.581c.575-.387.863-.91.863-1.57 0-.32-.074-.592-.22-.82-.147-.227-.384-.415-.711-.563a4.922 4.922 0 0 0-.948-.325 23.473 23.473 0 0 0-1.303-.24 77.899 77.899 0 0 1-1.505-.272 21.04 21.04 0 0 1-1.456-.359c-.62-.17-1.112-.37-1.472-.597a9.426 9.426 0 0 1-1.134-.854 2.97 2.97 0 0 1-.863-1.263 4.892 4.892 0 0 1-.27-1.674c0-1.616.597-2.873 1.793-3.773 1.196-.899 2.73-1.349 4.603-1.349 1.692 0 3.124.376 4.298 1.127 1.173.751 1.94 1.878 2.301 3.38l-3.079.889c-.181-.82-.599-1.434-1.253-1.844-.654-.41-1.41-.615-2.267-.615-.835 0-1.49.188-1.963.563-.474.376-.711.871-.711 1.486 0 .637.225 1.081.677 1.331.451.251 1.15.456 2.098.615.068 0 .327.04.779.12.451.08.755.131.914.153.157.023.456.086.896.188.44.103.762.194.965.273l.897.359c.394.16.688.319.88.478.234.196.465.395.694.597Zm8.596-5.173c-.813.638-1.366 1.537-1.659 2.698h9.003a4.152 4.152 0 0 0-1.455-2.612c-.813-.695-1.817-1.042-3.013-1.042-1.105 0-2.064.32-2.876.956Zm-3.114-1.536c1.579-1.593 3.565-2.39 5.957-2.39 2.346 0 4.269.757 5.77 2.27 1.5 1.514 2.251 3.512 2.251 5.993 0 .364-.023.751-.068 1.16h-12.658c.136 1.526.632 2.715 1.489 3.57.857.853 1.952 1.28 3.283 1.28 1.038 0 1.935-.262 2.691-.786.756-.523 1.224-1.263 1.405-2.22l3.181.957c-.429 1.617-1.303 2.851-2.623 3.705-1.32.853-2.872 1.28-4.654 1.28-2.414 0-4.416-.79-6.007-2.373-1.591-1.582-2.386-3.659-2.386-6.232 0-2.549.789-4.62 2.369-6.214Zm25.654-6.761c-1.083 0-1.895.296-2.437.888-.541.592-.812 1.388-.812 2.39v1.434h6.126v3.142h-6.126v13.385h-3.621V27.859h-3.25v-3.142h3.25v-1.673c0-2.003.58-3.511 1.742-4.525 1.162-1.012 2.646-1.519 4.451-1.519 1.331 0 2.606.194 3.824.58l-.473 2.903a8.002 8.002 0 0 0-2.674-.478Zm15.45 17.09c.688-.785 1.032-1.861 1.032-3.227v-9.151h3.621v16.527h-3.621V39.4c-1.129 1.457-2.731 2.185-4.806 2.185-1.783 0-3.289-.574-4.519-1.724-1.229-1.15-1.844-2.783-1.844-4.9V24.717h3.621v9.97c0 1.14.344 2.021 1.033 2.647.688.626 1.607.94 2.758.94 1.128 0 2.036-.394 2.725-1.179Zm8.782 4.149V17.34H164v23.903h-3.621Z"
          fill="#21566E"
        />
      </svg>
    </div>

    <h3 class="text-center grey--text text--darken-1 mt-13 mb-1">
      {{ $t('hostRating.label.title') }}
    </h3>

    <p class="body-2 text-center grey--text mb-8">
      {{ $t('hostRating.hint.about') }}
    </p>

    <div class="d-flex mw-250 mx-auto">
      <v-spacer />
      <v-icon
        v-for="rate in 5" :key="rate"
        @click="applyRating(rate)"
        :color="rating >= rate ? 'yellow darken-2' : 'grey lighten-2'"
        x-large
      >
        mdi-star
      </v-icon>
      <v-spacer />
    </div>

    <p class="text-center body-2 grey--text mt-4 mb-10">
      {{ $t('hostRating.hint.rating', { rating: rating }) }}
    </p>

    <v-form
      v-model="valid"
      @submit.prevent="sendValuation"
      ref="hostRateForm"
      lazy-validation
    >
      <v-textarea
        v-model="comment"
        :label="$t('hostRating.label.comment')"
        :rules="[rules.required, rules.minLength, rules.maxLength(240)]"
        :counter="240"
        outlined
      />
      <div class="text-right">
        <v-btn
          :loading="isCreatingHostRating"
          color="primary"
          elevation="0"
          type="submit"
        >
          {{$t('hostRating.action.sendRating')}}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, minLength, maxLength } from '@/util/errorHandling'

export default {
  name: 'HostRating',

  computed: {
    ...mapGetters(['isCreatingHostRating'])
  },

  methods: {
    ...mapActions([
      'createHostRating',
      'showErrorMessage',
      'showSuccessMessage',
    ]),

    applyRating(value) {
      this.rating = value
    },

    sendValuation() {
      if (!this.$refs.hostRateForm.validate()) return

      const appointment_id = this.$route?.params.id
      const is_real_estate = this.$route?.query?.realEstate

      if (!appointment_id) {
        this.showErrorMessage(this.$t('hostRating.messages.appointmentNotFound'))
        return
      }

      const rating = {
        rating: this.rating,
        comment: this.comment,
        appointment_id,
        is_real_estate,
      }

      this.createHostRating(rating)
    }
  },

  data() {
    return {
      valid: true,

      rating: 5,
      comment: '',

      rules: {
        required,
        minLength,
        maxLength,
      }
    }
  }
}
</script>
